import R from 'ramda'
import { getIndentedJSONString } from 'pages/widgets/mapping/common-functions'

const SEND_BLAST_ACTION_TYPE = 'SEND_BLAST'
const SEND_BLAST_DISPLAY_TYPE = 'Trigger blast'

const isSendBlastWidgetAction = R.propEq('type', SEND_BLAST_ACTION_TYPE)

const getQuickReply = R.pipe(
  R.path(['quickReply', 'options']),
  getIndentedJSONString
)

const getCtas = R.pipe(R.prop('ctas'), getIndentedJSONString)

const convertSendBlastWidgetActionToFormAction = R.applySpec({
  type: R.always(SEND_BLAST_DISPLAY_TYPE),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  quickReply: getQuickReply,
  ctas: getCtas,
  message: R.prop('message'),
  blastId: R.propOr(null, 'blastId')
})

export { isSendBlastWidgetAction, convertSendBlastWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-blast.js